import React, { Suspense } from 'react'
import HeaderBar from './pages/HeaderBar/HeaderBar';
import SplashScreen from './pages/SplashScreen/SplashScreen';
import OurGame from './pages/OurGame/OurGame';
import AboutUs from './pages/AboutUs/AboutUs';
import Contact from './pages/Contact/Contact';
import SainteArche from './pages/SainteArche/SainteArche';
import Screenshots from './pages/Screenshots/Screenshots';
import './App.css';
import Policy from './pages/Policy/Policy';

function App() {
  return (
    <div className="App">
      <HeaderBar />
      <Suspense fallback={<div>Chargement...</div>}>
        <SplashScreen />
        <OurGame />
        <Screenshots />
        <AboutUs />
        <SainteArche />
        <Contact />
        <Policy />
      </Suspense>
      <footer>
        2021 © Farlands Studio • Studio de jeux indépendant • 1.0.1
      </footer>
    </div>
  );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js